<template xmlns="http://www.w3.org/1999/html">
  <div class="privacy">
    <p class="title">隐私信息保护政策</p>
    <p style="text-align: left">发布时间：2019年5月28日<br />
      生效时间：2019年5月28日<br />
      更新时间：2026年8月31日
    </p>

    <p class="level1">我们非常重视您的隐私权</p>

    广州心与潮信息科技有限公司（以下简称：“心潮科技”）尊重并保护所有使用心潮移动客户端的用户（以下称为“您”）个人隐私与信息安全。鉴于此，心潮科技制定《心潮隐私信息保护政策》（以下称为“本政策”）与您确认关于您在使用心潮移动客户端期间，心潮科技将收集、存储、使用、管理和保护您的个人信息的相关事宜。在使用心潮移动客户端前，请您务必仔细阅读并透彻理解本政策，<span
      class="strong">特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。</span>在此过程中，如果您有任何疑问、意见或建议，您可通过心潮科技提供的各种联系方式与我们取得联系，我们会尽快为您作出解答。

    <p class="level2">一、心潮科技公司如何收集您的个人信息</p>
    <p>您在使用我们的产品或服务时，我们需要/可能需要收集和使用您的一些个人信息；用以向您提供服务、优化我们的服务以及保障您的账户安全。</p>

    <p class="level3 strong">（一）心潮 App 所收集的信息</p>
    <p class="level4 strong">1. 服务内容展示/浏览/播放/下载功能</p>
    <p><span class="strong">收集目的：</span>为保障您正常使用我们的<span
        class="strong">服务内容展示/浏览/播放/下载功能，</span>维护我们服务的正常运行，了解产品对不同硬件设备适配性、确保操作环境安全、识别帐号异常状态用途。</p>

    <p><span class="strong">收集方式及范围：</span>我们根据合法、正当、必要的原则，收集实现产品功能所必要的信息。您在软件安装或使用中同意授权隐私政策之后，收集您的<span
        class="strong">设备序列号、设备型号、操作系统、唯一设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、IP地址、操作日志、MAC地址、Android_ID、匿名设备标识符(OAID)、设备运行进程信息、应用程序安装列表信息、获取应用安装列表、获取设备传感器、蓝牙地址、读取设备IP。</span>
    </p>
    <p class="strong">其中设备运行进程信息、应用程序列表仅在设备本地使用，用于防止恶意程序和反作弊，并且不会上传服务器。</p>
    <p>我方客户端收集您的设备信息的频次与时机是<span class="strong">仅在您启动客户端时执行一次，且当客户端处于后台运行状态时，不会再次收集您的设备信息。</span></p>
    <p>我们收集这些信息是为了向您提供我们最核心的服务内容展示/播放/下载服务，如您拒绝提供上述信息或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息无法识别您的身份信息。</p>
    <p class="level4 strong">2. 日志信息</p>
    <p>
      当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存，用于帮助我们优化产品服务。包括您的搜索和浏览记录、关注、播放记录、访问量、播放时长、IP地址、WiFi网络、使用的语言、访问日期和时间。
    </p>
    <p class="level4 strong">3. 创建帐号功能</p>
    <p>当您在我方客户端创建帐号时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息，包括： <span
        class="strong">手机号码</span>、用户名。我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的产品或服务，并保护您的帐号安全。您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的此功能，请您谨慎考虑后再提供。
    </p>
    <p class="level4 strong">4. 第三方帐号信息</p>
    您使用第三方平台的帐号（<span
      class="strong">微信帐号、微博帐号、QQ帐号、通过Apple登录</span>）登录时，如果您决定绑定心潮帐号，经过您的帐号绑定授权，第三方平台会同步一部分信息给我方，如头像、昵称或ID。我们收集这些信息是用于为您提供帐号登录服务以及保障您的帐号安全，防范安全风险。如您拒绝授权此类信息的，您将无法使用第三方
    平台的帐号登录我们平台，但不影响我们为您提供的其他产品和服务的正常使用。
    <p class="level4 strong">5. 基本资料维护&身份验证</p>
    <p>【基本信息维护】您在使用我方客户端时，为维护您的基本资料，改善您的服务体验，需要您选择填写及/或完善服务必要的信息，可能包括您的性别、所在地、头像、昵称、生日。如您不提供这些信息，并不影响您对我方客户端核心功能使用。</p>
    <p>【身份验证】如果您的帐号遗失，我们将提供两种方式验证您的身份，如手机身份验证，或通过客服方式找回，在此过程中需您提供一些信息以验证您的身份。<span
        class="strong">在找回帐号时，我方可能需要您提供经常登录设备、经常收听内容 、注册时间，必要时需要提供支付订单凭证。</span>
    </p>
    <p class="level4 strong">6. 消息通知与定向推送</p>
    基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息，<span
      class="strong">例如您的浏览、搜索及播放记录、设备信息、位置信息、订单信息，我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐个性化内容。</span>
    <p>我们会根据您的个人信息（例如<span class="strong">浏览、搜索及播放记录、设备信息、位置信息、订单信息</span>），通过“消息通知”的方式向您提供或推广我们的商品和服务。</p>
    <p>同时，我们努力保障您的浏览体验，为您提供相应的退出机制，您可通过“<span class="strong">我的-系统设置-个性化内容推荐</span>”自主选择关闭定向推送功能。关闭后，您接收到的消息推送通知的相关性会降低。
    </p>
    <p class="level4 strong">7. 心率监测、心肺压力改善功能</p>
    您在使用心率监测、心肺压力改善功能时，我们会在征得您的同意后，申请允许摄像头权限，用于运行心率变化分析算法（数据仅用于即时的算法分析、不会收集、保存您的心率信息），以提供给您减压放松的服务。
    <p class="level4 strong">8. 您参加运营和互动活动</p>
    若您参加我方客户端的运营和互动活动，如兑换礼品、抽奖、参加竞猜、答题、问卷调查时，可能需要您主动提交有关信息。<span
      class="strong">例如对特定活动所领取的红包进行提现、奖品兑现和向税务机构完税，您可能需要提交身份证信息。</span>若奖品或者活动礼品需要寄送，您还需要提供地址信息。
    <p class="level4 strong">9. 为您提供VIP会员或订阅服务</p>
    为完成VIP会员费用支付，我们会记录您的支付方式和资金帐号，以实现原路径退款、活动红包提现、解除连续订阅会员服务、售后服务。我们会根据您选择的支付方式把您的订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在应用程序中嵌入的支付宝以及其他第三方支付的软件工具开发包（SDK）的方式与支付宝公司或其他第三方支付公司共享。同时，我们会记录并向您展示您帐号的订单信息，包括购买会员、睡贝充值信息。
    <p class="level4 strong">10. 客户服务及争议处理</p>
    <p>为向您提供客户服务，我们会记录您提供的联系方式和通信/通话记录和内容，用于与您联系和帮助您解决问题，或记录相关问题的处理方案及结果。</p>
    <p>为确认交易状态及为您提供会员VIP售后与争议解决服务，我们会通过您基于交易所选择的支付机构、支付方式收集与交易相关的<span
        class="strong">您的交易、支付信息（如iOS端的IAP支付的交易凭证和收费凭证）。</span></p>
    <p class="level4 strong">11. 安全保障功能</p>
    我们需要收集您的一些信息来保障您使用我们的产品或服务时的帐号与系统安全，并协助提升我们的产品服务的安全性和可靠性，以防产生任何危害用户、心潮科技、社会的行为，包括您的如下<span
      class="strong">个人信息：个人常用设备信息（包含：硬件型号、设备MAC地址、IMEI、IMSI）、
      登录IP地址、产品版本号、浏览记录、服务故障信息，以及个人敏感信息：手机号码、交易信息。</span>我们会根据上述信息来综合判断您帐号及交易风险、进行身份验证、客户服务、检测及防范安全事件、诈骗监测、存档和备份用途，并依法采取必要的记录、审计、分析、处置措施。一旦我们检测出存在或疑似存在帐号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同时，当发生帐号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。
    <p class="level3">（二）第三方 SDK 所收集的信息</p>
    <span
      class="strong">您授权同意</span>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。
    <p>我们的产品以集成 SDK 的方式，实现如下服务类型：</p>
    <p class="level4 strong">1. 数据统计、数据分析服务</p>
    <p class="level4 strong">（1）友盟+移动统计SDK（com.umeng.analytics）</p>
    <p><span class="strong">使用目的：</span>我们的产品集成友盟+SDK，友盟+SDK通过采集唯一设备识别码、获取设备硬件序列号（如<span>IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息</span>）对用户进行唯一标识，以便进行诸如用户新增等数据统计。在特殊情况下（如用户使用平板设备或电视盒子时），无法通过唯一设备识别码标识设备，我们会将设备MAC地址作为用户的唯一标识，以便正常提供统计分析服务。统计分析服务具备基础的反作弊功能，通过获取用户位置信息及IP地址，剔除作弊设备，同时矫正用户的地域分布数据，提高报表数据的准确性。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>友盟同欣（北京）科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>友盟+SDK采集唯一设备识别码、获取设备硬件序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、位置信息、网络信息、获取应用列表、获取iccid</p>
    <p><span class="strong">隐私政策链接：</span>https://www.umeng.com/page/policy</p>
    <p class="strong">个人信息类权限使用详情：</p>

    

      <p style="text-indent:2em">a. 读取手机状态数据<br/>
  &lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br/>
  该权限用于获取设备识别码、序列号 IMEI，通过 IMEI 对用户进行唯一标识，以便提供服务。</p>
      <p style="text-indent:2em">b. 访问地理位置信息<br/>
  &lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br/>
  &lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br/>
  该权限用于获取位置信息，为开发者提供反舞弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</p>
      <p style="text-indent:2em">c. 读取手机内存数据<br/>
  &lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br/>
  &lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br/>
  该权限用于保持设备相关信息，以确保设备唯一标识的准确性，以便精确向目标设备推送消息。在不同App间分享大图或多图文件时使用 。</p>
      <p style="text-indent:2em">d. 检测联网方式<br/>
  &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;<br/>
  该权限用于检测联网方式，在网络异常状态下避免数据发送，节省流量和电量。</p>
      <p style="text-indent:2em">e. 获取WIFI mac地址<br/>
  &lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;<br/>
  该权限用于获取WIFI mac地址，在平板设备或电视盒子上，无法通过IMEI标识设备，我们会将WIFI mac地址作为用户的唯一标识，以便正常提供统计分析服务。</p>
      <p style="text-indent:2em">f. 允许应用程序联网<br/>
  &lt;uses-permission android:name="android.permission.INTERNET" /&gt;<br/>
  该权限用于允许应用程序联网和发送统计数据的权限，以便提供统计分析服务。</p>

    <p class="level4 strong">（2）阿里云数据分析 SDK</p>
    <p><span class="strong">使用目的：</span>我们的产品集成阿里云数据分析 SDK，用于提供统计分析服务。阿里云数据分析 SDK，通过采集唯一设备识别码 IMEI、IMSI
      信息，对用户进行唯一标识，以便提供数据管理同步、统计分析的功能服务。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>

    <p><span class="strong">第三方名称：</span>阿里云计算有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>设备基础信息：唯一设备识别码 IMEI、IMSI
      信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</p>
    <p><span
        class="strong">隐私政策链接：</span>https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=a2c4g.11186623.0.0.f5bc28e6m8gSq9
    </p>

    <p class="strong">个人信息类权限使用详情：</p>

    <p style="text-indent:2em">a. 读取手机状态数据<br />
      &lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br />
      该权限用于获取设备的 IMEI、IMSI 信息，通过 IMEI 对用户进行唯一标识，以便提供服务。</p>


    <p class="level4 strong">（3）友盟组件化基础库 SDK</p>
    <p><span class="strong">使用目的：</span>我们的产品集成友盟组件化基础库SDK，采集唯一设备识别码、获取设备硬件序列号（如<span>IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息</span>）对用户进行唯一标识，以便进行诸如用户新增等数据统计。在特殊情况下（如用户使用平板设备或电视盒子时），无法通过唯一设备识别码标识设备，我们会将设备MAC地址作为用户的唯一标识，以便正常提供统计分析服务。统计分析服务具备基础的反作弊功能，通过获取用户位置信息及IP地址，剔除作弊设备，同时矫正用户的地域分布数据，提高报表数据的准确性。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>友盟同欣（北京）科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>友盟+SDK采集唯一设备识别码、获取设备硬件序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、位置信息、网络信息、获取应用列表、获取iccid</p>
    <p><span class="strong">隐私政策链接：</span>https://www.umeng.com/page/policy</p>

    <p class="level4 strong">2. 消息推送服务</p>
    我们因实现消息推送功能的需要，会使用小米、魅族、华为、OPPO、vivo 手机厂商的第三方 Push SDK。您使用小米、魅族、华为、OPPO、vivo 上述手机时，Push SDK 需要收集 <span class="strong">
      设备标识符（IMEI、OAID、IMSI、Android_ID、IDFA/IDFV）、设备运行进程信息、应用程序列表信息</span>。并可能会收集您的手机型号、系统类型、系统版本、联网相关信息，以确保您能正常收到消息推送，以及卸载客户端之后，不会再收到消息推送。
    <p class="level4 strong">（1）小米推送 SDK（ Milink SDK）</p>

    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>
    <p><span class="strong">第三方名称：</span>北京小米科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span class="strong">隐私政策链接：</span>https://dev.mi.com/distribute/doc/details?pId=1534</p>

    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的小米ID）、设备序列号build_serial、MAC地址。
    </p>
    <p class="level4 strong">（2）魅族推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>珠海星纪魅族信息技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span class="strong">隐私政策链接：</span>https://open.flyme.cn/docs?id=202</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的魅族ID）、设备序列号build_serial、MAC地址。
    </p>
    <p class="level4 strong">（3）华为推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>华为软件技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span
        class="strong">隐私政策链接：</span>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177
    </p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的华为ID）、设备序列号build_serial、MAC地址。
    </p>
    <p class="level4 strong">（4）OPPO推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>广东欢太科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span class="strong">隐私政策链接：</span>https://open.oppomobile.com/new/developmentDoc/info?id=10288</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的OPPO
      ID）、设备序列号build_serial、MAC地址。</p>
    <p class="level4 strong">（5）vivo推送 SDK</p>
    <p><span class="strong">使用目的：</span>实现消息推送服务</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>维沃移动通信有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span class="strong">隐私政策链接：</span>https://dev.vivo.com.cn/documentCenter/doc/652</p>
    <p class="strong">个人信息类权限使用详情：</p>
    <p style="text-indent:2em">a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p style="text-indent:2em">b. 应用程序安装列表信息、获取应用安装列表（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p style="text-indent:2em">c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivo
      ID）、设备序列号build_serial、MAC地址。</p>

    <p class="level4 strong">3. 短信验证登录服务</p>
    <p><span class="strong">使用目的：</span>我们使用了第三方（上海游昆信息技术有限公司，以下称“MobTech”）MobTech
      SMSSDK服务为您提供短信验证功能。为了顺利实现该功能，您需要授权MobTechSDK提供对应的服务;在您授权后，MobTech将收集您相关的<span
        class="strong">设备序列号、系统运营信息、网络状态信息、iOS广告标识符（IDFA）、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI），应用列表信息、基站信息</span>。关于MobTech所收集的信息种类、用途、个人信息保护的规则及退出机制，详见MobTech官网隐私政策
      （www.mob.com/about/policy）条款。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>上海游昆信息技术有限公司</p>
    <p><span
        class="strong">获取个人信息的范围：</span>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取iccid。
    </p>
    <p><span class="strong">隐私政策链接：</span>www.mob.com/about/policy</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    a. 读取手机状态数据
    &lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;
    该权限用于获取设备的 IMEI，通过 IMEI 对用户进行唯一标识，以便提供服务。
    <p class="level4 strong">4. 第三方帐号登录、分享服务</p>
    您使用微博、微信、QQ 帐号以及其他第三方帐号登录我们的产品时，相关SDK需要收集您的第三方帐号、设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、联网相关信息；如您使用向微博、微信、QQ 帐号以及其他第三方平台分享信息功能，相关 SDK
    会收集您的设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、联网相关信息。
    <p class="level4 strong">5. 崩溃、故障信息统计服务</p>

    <p class="level4 strong">（1）腾讯Bugly SDK</p>
    <p><span class="strong">使用目的：</span>我们的产品集成腾讯Bugly SDK，需要获取运行中进程信息、设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、WiFi地址（MAC地址）、运营商信息，用于提供崩溃日志上报、热修复、版本更新推送的服务。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理</p>

    <p><span class="strong">第三方名称：</span>深圳市腾讯计算机系统有限公司</p>
    <p><span
        class="strong">获取个人信息的范围：</span>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志。
    </p>
    <p><span class="strong">隐私政策链接：</span>https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</p>
    <p class="strong">个人信息类权限使用详情：</p>

    <table>
      <thead>
        <th>操作系统</th>
        <th>权限名称</th>
        <th>使用目的</th>
        <th>功能场景（申请时机）</th>
      </thead>
      <tbody>
        <tr>
          <td>安卓</td>
          <td>android.permission.INTERNET</td>
          <td>查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的</td>
          <td>在进程启动阶段及Crash闪退时调用，用于上传日志。</td>
        </tr>
        <tr>
          <td>安卓</td>
          <td>android.permission.ACCESS_NETWORK_STAT</td>
          <td>查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的</td>
          <td>在进程启动阶段及Crash闪退时调用，用于上传日志。</td>
        </tr>
        <tr>
          <td>iOS</td>
          <td>网络权限</td>
          <td>查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的</td>
          <td>在进程启动阶段及Crash闪退时调用，用于上传日志。</td>
        </tr>
      </tbody>
    </table>

    <!-- <p style="text-indent:2em">a. 读取手机状态数据<br/>
&lt;uses-permission android:name="android.permission.INTERNET /&gt;<br/>
&lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STAT" /&gt;<br/>
该权限用于查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的。</p> -->


    <p class="level4 strong">6. 客服反馈服务</p>
    <p>我们会向客服供应商、服务商（如腾讯兔小巢）提供您的用户昵称、设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV），以便支持我们进行相关的客户服务、售后服务，提升服务体验。</p>

    <p><span class="strong">7. 联运登录与支付服务</span></p>
    <p>为了给您和/或您的终端用户提供登录功能，会使用华为、小米、vivo 手机厂商的第三方联运 SDK，APP中集成的第三方SDK在静默状态下或在后台运行时会收集您的终端用户的设备相关信息（IMEI号（针对Android
      Q以及Q以下版本）、OAID、手机型号）和UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的联运帐号ID）。同时也会收集您的终端用户的软件相关信息（Android系统和SDK版本号、手机系统的版本号），以此针对不同设备为您的终端用户提供适配的应用服务功能。
    </p>
    <p>为了给您和/或您的终端用户提供支付功能，会使用华为、小米、vivo 手机厂商的第三方联运 SDK以及支付宝客户端 SDK、微信支付
      SDK，APP中集成的第三方SDK在静默状态下或在后台运行时会收集您的终端用户正在使用的应用ID、应用包名、应用商品名称、商品金额和安装渠道、UID和订单信息。订单信息包括：支付类型、订单ID、支付行为路径（包括支付点击、调起、成功、取消、失败）、优惠券、总订单金额、商品码、标识支付场景。
    </p>
    <p><span class="strong">（1）华为联运 SDK</span></p>
    <p><span class="strong">使用目的：</span>提供用户华为帐号登录功能与联运支付功能。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>华为软件技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span
        class="strong">隐私政策链接：</span>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050044906
    </p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p>a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p>b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p>c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的华为ID）、设备序列号build_serial、MAC地址。
    </p>
    <p><span class="strong">（2）小米联运 SDK</span></p>
    <p><span class="strong">使用目的：</span>提供用户小米帐号登录功能与联运支付功能。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>北京小米科技有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span class="strong">隐私政策链接：</span>https://dev.mi.com/distribute/doc/details?pId=1402</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p>a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p>b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p>c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的小米ID）、设备序列号build_serial、MAC地址。
    </p>
    <p><span class="strong">（3）vivo联运 SDK</span></p>
    <p><span class="strong">使用目的：</span>提供用户vivo帐号登录功能与联运支付功能。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>维沃移动通信有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>唯一设备识别码（IMEI/Android_ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI
      信息）、联网状态信息、获取位置信息、获取运行中进程信息、获取应用安装列表。</p>
    <p><span class="strong">隐私政策链接：</span>https://dev.vivo.com.cn/documentCenter/doc/712</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p>a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p>b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p>c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivoID）、设备序列号build_serial、MAC地址。
    </p>


    <p><span class="strong">（4）支付宝客户端 SDK</span></p>
    <p><span class="strong">使用目的：</span></p>
    <p>a. 保障用户账户和资金安全以及支付服务的安全稳定运行。</p>
    <p>b. 履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。</p>
    <p>c. 实现网络链路的选择和优化，以提升用户体验。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>支付宝（中国）网络技术有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi
      状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备序列号。</p>
    <p><span class="strong">隐私政策链接：</span>https://opendocs.alipay.com/common/02kiq3</p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p>a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p>b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p>c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivoID）、设备序列号build_serial、MAC地址。
    </p>



    <p><span class="strong">（5）微信支付 SDK</span></p>
    <p><span class="strong">使用目的：</span></p>
    <p>a. 保障用户账户和资金安全以及支付服务的安全稳定运行。</p>
    <p>b. 履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。</p>
    <p>c. 实现网络链路的选择和优化，以提升用户体验。</p>
    <p><span class="strong">处理方式：</span>第三方自行处理 </p>
    <p><span class="strong">第三方名称：</span>深圳市腾讯计算机系统有限公司</p>
    <p><span class="strong">获取个人信息的范围：</span>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi
      状态、Wi-Fi 参数、Wi-Fi 列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备序列号。</p>
    <p><span
        class="strong">隐私政策链接：</span>https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
    </p>
    <p><span class="strong">个人信息类权限使用详情：</span></p>
    <p>a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p>b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p>c. 设备标识符（如
      IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivoID）、设备序列号build_serial、MAC地址。
    </p>

    <!-- <p>a. 设备基础信息（如设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息）。</p>
    <p>b. 应用程序安装列表信息（如开发者应用名、应用包名、版本号、应用前后台状态、获取运行中进程信息）</p>
    <p>c. 设备标识符（如 IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、IDFA、Android_ID、DEVICEID、UID（依据您的终端用户选择的登录方式，我们可能会收集您的终端用户的vivoID）、设备序列号build_serial、MAC地址。</p> -->
    <p class="level4 strong">8.资源加载服务</p>
    <p>为了给您提供下载音频、图片资源的产品服务，我们需要接入七牛SKD以实现数据资源传输功能，以下将详细列出七牛 SDK 的各项业务功能及为实现该功能所需收集的个人信息情况，请仔细阅读下述信息清单了解各类七牛SDK（包括调用的第三方 SDK（如有））收集个人信息的类型、用途以及实现的功能目的。</p>
    <p class="strong">（1）七牛SDK</p>
    <p><span>使用目的：</span>提供音频文件下载完整性校验、以及用户帐号头像上传的服务</p>
    <p><span>处理方式：</span>第三方自行处理 </p>
    <p><span>第三方名称：</span>上海七牛信息技术有限公司</p>
    <p><span>获取个人信息的范围：</span>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</p>
    <p><span>隐私政策链接：</span>https://developer.qiniu.com/pili/8027/sdk-privacy-policy</p>



    <p>
      我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <p>提供技术服务的第三方SDK提供商。关于提供商的身份、收集个人信息的目的、方式、范围等情况，请您详细参见本政策附件一、二。</p>
    <p class="level3 strong">（三）基于系统权限的附加功能服务</p>
    <p>
      我们在向您提供的以下附加服务中可能会收集和使用您的个人信息以及申请设备权限。如果您不提供这些信息，不会影响您使用我们客户端的浏览、搜索、购买等基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些信息是需要您配合开启相应的设备权限方可获取，因此您
      可以通过设备设置页面相应权限进行管理。这些附加服务包括：</p>
    <p class="level4 strong">1. Android 版本基于系统权限的功能服务</p>
    <p><span class="strong">（1）基于存储空间权限的附加服务：</span>您在心潮内更新个人头像时，心潮会请求获取存储空间权限用于访问相册，以确保可以正常选择头像图片。</p>
    <p><span
        class="strong">（2）基于相机权限的附加服务：</span>您在心潮内使用心率监测、快速减压、考前减压功能时，心潮会请求获取相机权限，以提供分析心率变化服务，完善功能体验流程；在心潮内更新个人头像时，心潮会请求获取相机权限，以确保可以通过拍照的方式更新个人头像。
    </p>
    <p class="level4 strong">2. iOS 版本基于系统权限的功能服务</p>
    <p><span class="strong">（1）基于相机权限的附加服务：</span>
      您在心潮内使用心率监测、快速减压、考前减压功能时，心潮会请求获取相机权限，以提供分析心率变化服务，完善功能体验流程；在心潮内更新个人头像时，心潮会请求获取相机权限，以确保可以通过拍照的方式更新个人头像。</p>
    <p><span class="strong">（2）基于 Health Kit 数据的附加服务：</span> 当你需要使用Health Kit（中文名叫健康，后续文案表述统一为Health
      Kit）服务与我们产生数据链接时，首先需要你“打开心潮”-“我的”-“心率设置”-打开“健康中心”（默认关闭），此时，我们会明确告知你我们需要获取数据及简要功能说明，如你确认需要使用Health
      Kit服务，请你点击“同意”，反之，你可以“拒绝”。</p>
    <p>b. 当你同意我们与Health Kit服务产生数据链接时，请你在“心率”类目中允许“心潮”心率数据写入到Health Kit里，这将有利于你更好更方便管理心率，除此之外，我们承诺不会从Health
      Kit获取其他无关数据。</p>
    <p>c. 我们承诺你通过我们使用Health Kit的数据不会用于广告或应用其他商业化服务目的。同时请你也注意，你使用我们服务可能会存在广告，但是你使用Health Kit中的数据不会用于广告或应用其他商业化服务目的。</p>
    <p>d. 我们承诺不会向任何第三方展示、出售任何Health Kit获取数据，并且我们承诺建立严密技术措施确保你数据的安全。</p>
    <p>您理解并同意，上述附加服务可能需要您在您的设备中开启您的摄像头（相机）、相册（图片库）、Health
      Kit（健康）。您可在您的设备设置，如果因为更新版本的问题，在您的App上述路径无法找到关闭通讯录权限的选项，您需要去您的设备设置中针对心潮App关闭通讯录权限。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
    </p>

    <p class="level3">（四）客户端调用权限与用途说明</p>
    <p>在您的使用我方客户端功能服务的过程中，体验功能需要调用客户端或SDK时，将会调用如下设备权限，以保障正常的功能实现。为了您更好的理解与使用我们的功能服务，您可以通过下方列举的权限使用说明进行了解：</p>

    <p>1. 允许程序访问<br />
      &lt;uses-permission android:name="android.permission.GET_TASKS" /&gt;<br />
      小米SDK的消息推送服务。</p>

    <p> 2. 获取wifi状态<br />
      &lt;uses-permission android:name="android.permission.ACCESS_WIFI_STATE" /&gt;<br />
      该权限用于基础的连接网络功能。</p>

    <p> 3. 获取网络状态<br />
      &lt;uses-permission android:name="android.permission.ACCESS_NETWORK_STATE" /&gt;<br />
      用于基础的连接网络功能。</p>

    <p> 4. 访问网络<br />
      &lt;uses-permission android:name="android.permission.INTERNET" /&gt;<br />
      该权限用于基础的连接网络功能。</p>

    <p> 5. 照相机<br />
      &lt;uses-permission android:name="android.permission.CAMERA" /&gt;<br />
      该权限用于心率监测、快速减压、考前减压功能提供分析心率变化服务；通过拍照的方式更新个人头像。</p>

    <p> 6. 加入电池优化白名单<br />
      &lt;uses-permission android:name="android.permission.REQUEST_IGNORE_BATTERY_OPTIMIZATIONS" /&gt;<br />
      该权限用于保障心潮后台运行稳定性。</p>

    <p> 7. 获取精确定位<br />
      &lt;uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" /&gt;<br />
      该权限用于友盟统计SDK的数据分析服务。</p>

    <p> 8. 获取粗略定位<br />
      &lt;uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" /&gt;<br />
      该权限用于友盟统计SDK的数据分析服务。</p>

    <p> 9. 安装App<br />
      &lt;uses-permission android:name="android.permission.REQUEST_INSTALL_PACKAGES" /&gt;<br />
      该权限用于提供App版本更新功能。</p>

    <p> 10. 推送通知<br />
      &lt;uses-permission android:name="com.coloros.mcs.permission.RECIEVE_MCS_MESSAGE" /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 11. 推送通知<br />
      &lt;permission android:name="com.psyone.brainmusic.permission.receiver /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 12. 推送通知<br />
      &lt;permission android:name="com.psyone.brainmusic.permission.MIPUSH_RECEIVE"/&gt;<br />
      该权限用于小米推送通知服务。</p>

    <p> 13. 推送通知<br />
      &lt;uses-permission android:name="com.heytap.mcs.permission.RECIEVE_MCS_MESSAGE" /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 14. 推送通知<br />
      &lt;uses-permission android:name="com.meizu.flyme.push.permission.RECEIVE" /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 15. 推送通知<br />
      &lt;permission android:name="com.psyone.brainmusic.push.permission.MESSAGE" android:protectionLevel="0x2"
      /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 16. 推送通知<br />
      &lt;uses-permission android:name="com.psyone.brainmusic.push.permission.MESSAGE" /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 17. 推送通知<br />
      &lt;uses-permission android:name="com.meizu.c2dm.permission.RECEIVE" /&gt;<br />
      该权限用于魅族推送通知服务。</p>

    <p> 18. 推送通知<br />
      &lt;permission android:name="com.psyone.brainmusic.permission.C2D_MESSAGE" android:protectionLevel="0x2"
      /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 19. 推送通知<br />
      &lt;uses-permission android:name="com.psyone.brainmusic.permission.C2D_MESSAGE" /&gt;<br />
      该权限用于推送通知服务。</p>

    <p> 20. 推送通知<br />
      &lt;uses-permission android:name="com.psyone.brainmusic.permission.MIPUSH_RECEIVE" /&gt;<br />
      该权限用于小米推送通知服务。</p>

    <p> 21. 照相机<br />
      &lt;uses-feature android:name="android.hardware.camera" android:required="false" /&gt;<br />
      该权限用于心率监测、快速减压、考前减压功能提供分析心率变化服务；通过拍照的方式更新个人头像。</p>

    <p> 22. 照相机自动对焦功能<br />
      &lt;uses-feature android:name="android.hardware.camera.autofocus" android:required="false" /&gt;<br />
      该权限用于过拍照的方式更新个人头像。</p>

    <p> 23. 访问闪光灯<br />
      &lt;uses-permission android:name="android.permission.FLASHLIGHT" /&gt;<br />
      该权限用于心率监测、快速减压、考前减压功能提供分析心率变化服务。</p>

    <p> 24. 允许振动<br />
      &lt;uses-permission android:name="android.permission.VIBRATE" /&gt;<br />
      该权限用于心率监测、快速减压、考前减压功能提供分析心率变化服务。</p>

    <p> 25. 允许程序后台运行<br />
      &lt;uses-permission android:name="android.permission.WAKE_LOCK" /&gt;<br />
      该权限用于音频后台播放服务。</p>

    <p> 26. 允许写入外部存储<br />
      &lt;uses-permission android:name="android.permission.WRITE_EXTERNAL_STORAGE" /&gt;<br />
      该权限用于下载音频服务。</p>

    <p> 27. 建立前台服务<br />
      &lt;uses-permission android:name="android.permission.FOREGROUND_SERVICE" /&gt;<br />
      该权限用于音频播放服务。</p>

    <p> 28. 改变网络状态<br />
      &lt;uses-permission android:name="android.permission.CHANGE_NETWORK_STATE" /&gt;<br />
      该权限用于联运支付功能。</p>

    <p> 29. 改变WiFi状态<br />
      &lt;uses-permission android:name="android.permission.CHANGE_WIFI_STATE" /&gt;<br />
      该权限用于联运支付功能。</p>

    <p> 30. 读取手机状态<br />
      &lt;uses-permission android:name="android.permission.READ_PHONE_STATE" /&gt;<br />
      该权限用于消息推送服务 。</p>

    <p> 31. 修改系统设置<br />
      &lt;uses-permission android:name="android.permission.WRITE_SETTINGS" /&gt;<br />
      该权限用于跳转系统设置后台白名单。</p>

    <p> 32. 读取外部存储空间<br />
      &lt;uses-permission android:name="android.permission.READ_EXTERNAL_STORAGE" /&gt;<br />
      该权限用于音频播放服务。</p>


    <p class="level3">（五）其他</p>
    <p class="strong">
      1．若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第九条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。
    </p>
    <p class="strong">2．若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>
    <p>
      若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
    </p>
    <p>我方平台涉及嵌入第三方代码、插件传输个人信息的情形逐项列举，详见本政策附件一。</p>
    <p class="strong">3. 征得授权同意的例外</p>
    <p>您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
    <p>(1) 与国家安全、国防安全有关的；</p>
    <p>(2) 与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>(3) 与犯罪侦查、起诉、审判和判决执行司法或行政执法有关的；</p>
    <p>(4) 出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</p>
    <p>(5) 您自行向社会公众公开的个人信息；</p>
    <p>(6) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
    <p>(7) 根据与您签订和履行相关协议或其他书面文件所必需的；</p>
    <p>(8) 用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；</p>
    <p>(9) 为合法的新闻报道所必需的；</p>
    <p>(10) 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>(11) 法律法规规定的其他情形。</p>
    <p class="level2">二、心潮科技公司如何使用Cookie以及同类技术</p>
    <p>Cookie 和同类技术是互联网中普遍使用的技术。当您使用我方客户端相关服务时，我们可能会使用相关技术收集您的信息。我们使用 Cookie 和 同类技术主要为了实现以下功能或服务：</p>
    <p class="level3 strong">（一）保障产品与服务的安全、高效运转</p>
    <p>我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者 是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
    <p class="level3 strong">（二）帮助您获得更轻松的访问体验</p>
    <p>使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（例如：表单填写）。</p>
    <p>您可以通过浏览器设置拒绝或管理Cookie以及同类技术的使用；但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>
    <p class="level2">三、心潮科技公司如何使用、转移、披露您的个人信息</p>
    <p class="level3">（一）共享和披露</p>
    <p>除下列情形外，我们不会与任何其他第三方共享您的个人信息。</p>
    <p><span class="strong">1.
        在获得您的明确同意或授权或您主动选择的情况下共享。</span>获得您的明示授权或明确同意后，我们会与其他公司、组织和个人分享您的个人信息。例如，如果我们委托第三方向您提供产品或服务（如产品寄送、用户活动、礼品赠送时），我们会在征得您明示同意后将上述信息共享给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。只有您选择同意，我们才会共享您的个人敏感信息。获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息。
    </p>
    <p><span class="strong">2.
        在法定情形下的共享和披露。</span>我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。例如，如果我们确定您出现违反法律法规或严重违反我方相关协议规则的情况，或为保护我方客户端及用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或我方客户端相关协议规则，在征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我方平台已对您采取的措施。例如，若您或您使用的帐号发布非法言论、而严重违反我方规则、触犯法律法规和/或违背公序良俗，造成重大社会影响，给我方造成声誉损失，我们可能会披露您的信息与处罚情况。
    </p>
    <p><span class="strong">3.
        向我方的关联方分享您的个人信息。</span>与关联公司间共享：为便于我们基于关联帐号共同向您提供服务，推荐您可能感兴趣的信息或保护我方关联公司或其他用户或公众的人身财产安全免遭侵害，在经过您的授权同意后，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用我方帐号登录并使用我们关联公司产品或服务，我们会向关联公司共享您必要的个人信息），且受本隐私信息保护政策中所声明目的的约束。如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的明示授权同意。
    </p>
    <p><span class="strong">4.
        与授权合作伙伴共享。您授权同意</span>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。
    </p>
    <p>目前，我们的授权合作伙伴包括以下类型：</p>

    <p class="strong">（1）数据统计、数据分析服务类的授权合作伙伴。我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android
      ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
    <p>
      除上述得到您的许可的情形外，我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或手机号码，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。
    </p>

    <p class="strong">
      请您理解，单独的设备信息、日志信息及其他无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
    </p>

    <p><span
        class="strong">（2）供应商、服务提供商和其他合作伙伴。</span>我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴（如腾讯Bugly），这些支持包括我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、支付便利或进行学术研究和调查，进行Bug或者崩溃统计、提升登录体验，实现网关取号。为了提供客户服务，我们会向客服供应商、服务商（如腾讯兔小巢）提供您的用户昵称、设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV），以便支持我们进行相关的客户服务、售后服务，提升服务体验。
    </p>
    <p>
      （3）为了使您能够接收信息推送、在第三方平台分享信息、使用位置服务的必要的功能用途，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序。如您使用华为/小米/魅族/OPPO/vivo手机时，华为/小米/魅族/OPPO/vivo
      Push
      SDK需要读取您的设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、联网相关信息，用于推送/下发通知栏消息；如您使用微博、微信、QQ帐号以及其他第三方帐号登录我们的产品时，相关SDK需要收集您的第三方帐号、设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、联网相关信息；如您使用向微博、微信、QQ帐号以及其他第三方平台分享信息功能，相关SDK会收集您的设备标识符（IMEI、OAID、Android_ID、IDFA/IDFV）、联网相关信息。
    </p>
    <p>
      我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <p>提供技术服务的第三方SDK提供商。关于提供商的身份、收集个人信息的目的、方式、范围等情况，请您详细参见本政策附件一、二。</p>
    <p><span class="strong">5.
        协助处理争议。</span>如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。如交易任何投诉一方、司法机构或行政执法机构提出信息披露请求的，我方会视情况向该上述机构提供被投诉用户的联络方式及个人必要信息，以促成交纠纷的解决。我方平台仅在法律有明确规定的情况下承担相应的法律责任。
    </p>
    <p><span class="strong">6.
        提供和改进产品和服务。</span>为了进一步完善产品或服务，提供更优质的用户体验，心潮科技公司将使用您提供的信息自行或提供给数据服务商进行数据统计、分析，以评估、维护和改进心潮科技公司产品或服务的性能。<span
        class="strong">这些信息在使用前会经过匿名化处理的，将不会包含您的任何身份识别信息。</span></p>
    <p><span class="strong">7. 数据转移。</span>若心潮科技公司发生重组、合并、分立、清算或资产出售时，您的信息将作为交易标的转移到新的主体，在本政策变更前，您的个人信息仍然受到本个人信息保护政策的保护。
    </p>
    <p class="level3">（二）转让</p>
    <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
    <p>
      2.在我方服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
    <p class="level3">（三）共享、转让、披露个人信息时事先征得授权同意的例外</p>
    <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
    <p>1.与国家安全、国防安全有关的；</p>
    <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3.与犯罪侦查、起诉、审判和判决执行有关的；</p>
    <p>4.出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</p>
    <p>5.您自行向社会公众公开的个人信息；</p>
    <p>6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
    <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
    <p class="strong">如您不同意我们按照上述条款向第三方提供您的个人信息，请您立即停止使用我方客户端服务。</p>
    <p class="level2">四、心潮科技公司如何存储信息</p>
    <p class="level3">（一）信息存储的地点</p>
    <p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
    <p>1.法律法规有明确规定；</p>
    <p>2.获得您的明确授权；</p>
    <p>针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</p>
    <p class="level3">（二）信息存储期限</p>
    <p>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：</p>
    <p class="strong">1、完成与您相关的服务目的、维护相应服务及业务记录、应对您可能的查询或投诉；</p>
    <p class="strong">2、保证我们为您提供服务的安全和质量；</p>
    <p class="strong">3、您是否同意更长的留存期间；</p>
    <p class="strong">4、是否存在保留期限的其他特别约定。</p>
    <p>在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
    <p class="level3">（三）信息删除和匿名化处理</p>
    如本公司服务决定停止运营，我们将在相关服务停止运营后停止继续收集您的个人信息。我们将以公告形式将停止运营通知向您送达。对已持有的您的个人信息将进行删除或匿名化处理。涉及儿童个人信息的，我们会一并将停止运营的通知及时告知儿童监护人。
    <p class="level2">五、 心潮科技公司如何保护您的个人信息安全</p>
    为确保我们所收集的您的个人信息安全，我们承诺将努力达到合理的安全水平，现将具体安全措施和安全能力陈述如下：
    <p class="level3">（一）技术安全防护</p>
    为保障您的信息安全，我们努力采取各种符合业界标准的合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
    <p class="level3">（二）安全体系保证</p>
    我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或我方客户端相关协议规则的情况，我方平台对系统进行了等级保护。
    <p class="level3">（三）人员安全管理</p>
    我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况以及其他措施。我方会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我方将尽力做到使您的信息不被泄漏、毁损或丢失。我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    <p class="level3">（四）敏感信息及保护提示</p>
    <p><span class="strong">1.
        个人敏感信息保护注意：</span>您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，例如您的头像图片上传，例如您在评论时选择上传包含的个人信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
    </p>
    <p><span class="strong">2.
        您的帐号均有安全保护功能，请妥善保管您的帐号信息。</span>我方将通过向其它服务器备份、对用户密码进行加密以及其他安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
    </p>
    <p class="level3">（五）信息披露提示及密码泄露处理</p>
    请注意互联网并非绝对安全的环境。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的帐号及密码发生泄露，请您立即联络我方客服，以便我方采取相应措施。
    <p class="level3">（六）信息安全事件处理</p>
    在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以邮件、电话、推送通知、短消息的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
    <p class="level3">（七）儿童个人信息安全</p>
    <p>我们严格设定儿童个人信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。</p>
    <p>
      我们已制定儿童个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施。我们将及时将事件相关情况以App推送通知、发送邮件/短消息的方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。
    </p>
    <p class="level2">六、 未成年人保护</p>
    <p>我们非常重视对未成年人的个人信息保护。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私信息保护政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</p>
    <p>若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务。如您对您所监护的儿童的个人信息有疑问，请通过第九章节中的联系方式与我们联系。</p>
    <p class="level2">七、 您如何管理您的信息</p>
    我们按《中华人民共和国网络安全法》的要求，通过提供便捷的方法，让您可以访问、更正及删除自己的帐号信息或使用我们的服务时您提供的其他个人信息。您可以通过如下方式访问及管理您的个人信息：
    <p class="level3">（一）访问您的个人信息</p>
    <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
    <p>帐号信息——如果您希望访问或编辑您的帐号中的个人基本资料信息、或注销您的帐号，您可以登录帐号通过“帐号与资料”执行此类操作；例如您可以移动客户端“我的 -
      帐号与资料”查询、修改自己的个人资料、隐私设置并修改您的个人注册信息。</p>
    <p class="level3">（二）更正或补充您的个人信息</p>
    当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。
    <p class="level3">（三）删除您的个人信息</p>
    <p>您可以通过“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p class="strong">1．如果我们处理个人信息的行为违反法律法规；</p>
    <p class="strong">2．如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
    <p class="strong">3．如果我们处理个人信息的行为严重违反了与您的约定；</p>
    <p class="strong">4．如果您不再使用我们的产品或服务，或您主动注销了帐号；</p>
    <p class="strong">5．如果我们永久不再为您提供产品或服务</p>
    <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
    <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
    <p class="level3">（四）改变您授权同意的范围</p>
    <p>每个业务功能需要一些基本的个人信息才能得以完成。除此之外，对于额外个人信息的收集和使用，您可以与我方客服联系，给予或收回您的授权同意。</p>
    <p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
    <p class="level3">（五）个人信息主体注销帐号</p>
    <p>现阶段，我方已通过技术方式实现，使您可以自行在“注销帐号”页面（心潮移动客户端“我的 - 帐号与资料 -
      注销帐号”）提交帐号注销申请。若未能申请成功，您也可联系我方客服。我们在核实用户身份后，会注销您的手机号和使用记录，达到注销的效果。</p>
    <p class="strong">在您主动注销帐号之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或对其匿名化处理。</p>
    <p class="level3">（六）约束信息系统自动决策</p>
    在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我方平台商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
    <p class="level3">（七）退订</p>
    如您发现收到了不属于您主动搜索、浏览的内容和产品、服务信息推送，如您不希望接收上述信息，可通过原路径进行退订，例如短信推送可以直接回复相关的退订口令，如会员连续包月服务在客户端内“会员 - 续费管理”取消您的连续包月服务。
    <p class="level3">（八）响应您的上述请求</p>
    为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    <p class="level2">八、个人信息保护政策的修订</p>
    <p class="strong">
      心潮科技公司可能对本政策进行不定期修改，协议修改后，心潮科技公司将在相关页面或以其他合适的方式公布修改的内容。如果您不同意本协议的修改，请立即停止使用平台或取消已经获得的服务；如果您选择在本政策修改后继续访问或使用平台或服务的，则视为您已接受本政策的修改。
    </p>
    <p>您与心潮科技公司签署的本政策所列明的条款，并不能完全涵盖您与心潮科技公司所有的关于个人信息的权利和义务。因此，<span class="strong">
        心潮科技公司公布其他声明、各形式规则均视为本政策之补充条款，为本政策不可分割的组成部分，与本协议具有同等法律效力。</span>
    </p>
    <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在心潮科技公司专门链接上发布对隐私权政策所做的任何变更和更新。
      对于重大变更，我们还会提供更为显著的通知（包括我们会通过我方平台公示的方式进行通知甚至向您提供弹窗提示）。</p>
    <p>本政策所指的重大变更包括但不限于：</p>
    <p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
    <p>2.我们在控制权方面发生重大变化。如并购重组引起的所有者变更；</p>
    <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
    <p>6.个人信息安全影响评估报告表明存在高风险时。</p>
    <p>
      为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。我们鼓励您在每次使用我们服务时都查阅本政策。您可以在心潮客户端通过“我的-关于我们-隐私政策”中查看本政策。
    </p>
    <p class="level2">九、如何联系心潮科技公司</p>
    <p>您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求：
      我们设立了个人信息保护专职部门，如您对心潮科技隐私信息保护政策、儿童个人信息有任何疑问、意见或建议，您可通过以下方式与我们取得联系：<br />
      我方地址：广州市海珠区新滘中路10号之三101、之四101、之五101<br />
      联系人：心潮科技客服部<br />
      联系方式：020-87351934<br />
      联系邮箱：office@heartide.com</p>

    <p>本协议签订地为中华人民共和国广州市海珠区，因本协议生效、履行、解释及使用心潮科技公司服务而产生或与本协议相关的一切争议、权利主张或其他事项，均适用中华人民共和国法律（港澳台地区除外 ）。</p>
    <p>您与心潮科技公司或心潮移动客户端发生的一切争议，应友好协商，如协商不成的，可选择按下述任一途径解决：</p>
    <p>（一） 提交仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对各方均有约束力；</p>
    <p>（二） 提交协议签订地人民法院诉讼管辖；<br />
      请您再次确认您已全部阅读并充分理解上述条款 。</p>
    <p>注：本政策版本更新日期为2026年8月31日，如您认为更新的政策对您更为有利，我们同意双方适用新的政策内容。</p>
    <p style="text-align: right" class="strong">广州心与潮信息科技有限公司<br />
      2026年8月31日</p>
    <p class="level2">附件一：《iOS版本心潮App涉及个人信息传输的SDK情况表》</p>
    <table>
      <thead>
        <tr>
          <th>序号</th>
          <th>SDK名称</th>
          <th>应用场景描述</th>
          <th>获取个人信息/权限</th>
          <th>第三方机构名称</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>友盟+移动统计SDK</td>
          <td>提供统计分析服务</td>
          <td>唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、位置信息、网络信息、获取应用列表、获取iccid</td>
          <td>友盟同欣（北京）科技有限公司</td>
        </tr>
        <tr>
          <td>2</td>
          <td>七牛SDK</td>
          <td>提供音频文件下载完整性校验、以及用户帐号头像上传的服务</td>
          <td>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</td>
          <td>上海七牛信息技术有限公司</td>
        </tr>
        <tr>
          <td>3</td>
          <td>腾讯Bugly SDK</td>
          <td>提供崩溃日志上报、热修复、版本更新推送的服务</td>
          <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志。
          </td>
          <td>深圳市腾讯计算机系统有限公司</td>
        </tr>
        <tr>
          <td>4</td>
          <td>友盟分享SDK</td>
          <td>提供第三方帐号登录与内容分享</td>
          <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、获取应用列表、获取iccid</td>
          <td>友盟同欣（北京）科技有限公司</td>
        </tr>
        <tr>
          <td>5</td>
          <td>移动智能终端补充设备标识体系SDK</td>
          <td>访问移动智能终端补充设备标识体系</td>
          <td>OAID（开放匿名设备标识符）、应用匿名设备标识符（AAID）、IDFA（广告标识符）、设备硬件序列号、MAC 地址</td>
          <td>中国信息通信研究院</td>
        </tr>
      </tbody>
    </table>
    <p class="level2">附件二：《Android版本心潮App涉及个人信息传输的SDK情况表》</p>

    <table>
      <thead>
        <tr>
          <th>序号</th>
          <th>SDK名称</th>
          <th>应用场景描述</th>
          <th>获取个人信息/权限</th>
          <th>第三方机构名称</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>友盟+移动统计SDK</td>
          <td>提供统计分析服务</td>
          <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、获取应用列表、获取iccid</td>
          <td>友盟同欣（北京）科技有限公司
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>七牛SDK</td>
          <td>提供音频文件下载完整性校验、以及用户帐号头像上传的服务</td>
          <td>设备品牌、型号、操作系统版本、处理器信息、内存使用情况、IP 地址、网络类型及连接信息、读取设备外部存储空间、获取设备硬件序列号、获取 MAC 地址</td>
          <td>上海七牛信息技术有限公司</td>
        </tr>
        <tr>
          <td>3</td>
          <td>腾讯Bugly SDK</td>
          <td>提供崩溃日志上报、热修复、版本更新推送的服务</td>
          <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志。
          </td>
          <td>深圳市腾讯计算机系统有限公司</td>
        </tr>
        <tr>
          <td>4</td>
          <td>友盟分享SDK</td>
          <td>提供第三方帐号登录与内容分享</td>
          <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、获取应用列表、获取iccid</td>
          <td>友盟同欣（北京）科技有限公司
          </td>
        </tr>
        <tr>
          <td>5</td>
          <td>FileDownloader SDK</td>
          <td>提供音频文件下载保存的服务</td>
          <td>读取您的设备外部存储空间</td>
          <td>开源项目</td>
        </tr>
        <tr>
          <td>6</td>
          <td>takephoto_library SDK</td>
          <td>提供帐号头像图片裁剪的服务</td>
          <td>读取您的设备外部存储空间</td>
          <td>开源项目</td>
        </tr>
        <tr>
          <td>7</td>
          <td>微信支付SDK</td>
          <td>提供微信支付服务
            a.保障用户账户和资金安全以及支付服务的安全稳定运行。
            b.履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。
            c.实现网络链路的选择和优化，以提升用户体验。</td>
          <td>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi
            列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备序列号。</td>
          <td>深圳市腾讯计算机系统有限公司</td>
        </tr>
        <tr>
          <td>8</td>
          <td>支付宝客户端SDK</td>
          <td>提供支付宝支付服务
            a.保障用户账户和资金安全以及支付服务的安全稳定运行。
            b.履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务。
            c.实现网络链路的选择和优化，以提升用户体验。
          </td>
          <td>Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi
            列表；开放匿名设备标识符、MAC地址、IMEI信息、传感器、设备序列号。
          </td>
          <td>支付宝（中国）网络技术有限公司</td>
        </tr>
        <tr>
          <td>9</td>
          <td>魅族推送SDK</td>
          <td>提供消息通知的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>珠海市魅网科技有限公司</td>
        </tr>
        <tr>
          <td>10</td>
          <td>华为推送SDK</td>
          <td>提供消息通知的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>华为技术有限公司</td>
        </tr>
        <tr>
          <td>11</td>
          <td>小米推送SDK</td>
          <td>提供消息通知的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>北京小米科技有限公司</td>
        </tr>
        <tr>
          <td>12</td>
          <td>OPPO推送SDK</td>
          <td>提供消息通知的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>OPPO广东移动通信有限公司</td>
        </tr>
        <tr>
          <td>13</td>
          <td>vivo推送SDK</td>
          <td>提供消息通知的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>维沃移动通信有限公司</td>
        </tr>
        <tr>
          <td>14</td>
          <td>Zxing二维码扫描SDK</td>
          <td>仅用于内部调试，不对外开放</td>
          <td>无</td>
          <td>Google公司</td>
        </tr>
        <tr>
          <td>15</td>
          <td>Glide SDK</td>
          <td>提供加载图片内容的服务</td>
          <td>读取设备IP</td>
          <td>开源项目</td>
        </tr>
        <tr>
          <td>16</td>
          <td>OkHttp SDK</td>
          <td>以提供网络请求的服务</td>
          <td>无</td>
          <td>开源项目</td>
        </tr>
        <tr>
          <td>17</td>
          <td>RxJava SDK</td>
          <td>提供响应式编程框架基础服务</td>
          <td>无</td>
          <td>开源项目</td>
        </tr>

        <tr>
          <td>18</td>
          <td>华为联运SDK</td>
          <td>提供应用内支付购买的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>华为技术有限公司</td>
        </tr>
        <tr>
          <td>19</td>
          <td>小米联运SDK</td>
          <td>提供应用内支付购买的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>北京小米科技有限公司</td>
        </tr>
        <tr>
          <td>20</td>
          <td>vivo联运SDK</td>
          <td>提供应用内支付购买的服务</td>
          <td>设备基础信息：唯一设备识别码 IMEI、IMSI
            信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
          <td>维沃移动通信有限公司</td>
        </tr>
        <tr>
          <td>21</td>
          <td>移动智能终端补充设备标识体系SDK</td>
          <td>访问移动智能终端补充设备标识体系</td>
          <td>OAID（开放匿名设备标识符）、VAID（开发者匿名设备标识符）、AAID（应用匿名设备标识符）、设备硬件序列号、Android ID、MAC 地址</td>
          <td>中国信息通信研究院</td>
        </tr>
        <tr>
          <td>22</td>
          <td>AndroidGifDrawable SDK </td>
          <td>显示动画gif组件</td>
          <td>无</td>
          <td>开源项目</td>
        </tr>
        <tr>
          <td>23</td>
          <td>SpringFramework SDK</td>
          <td>基础架构组件</td>
          <td>无</td>
          <td>开源项目</td>
        </tr>

        <tr>
          <td>24</td>
          <td>ReactiveStreams SDK</td>
          <td>加载响应组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>25</td>
          <td>Sanselan SDK</td>
          <td>图片处理组件</td>
          <td>无</td> 
          <td>ApacheSoftware公司</td>
        </tr>
        <tr>
          <td>26</td>
          <td>ApacheHttp SDK</td>
          <td>HTTP和相关协议的底层框架</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>27</td>
          <td>Okio SDK</td>
          <td>基础架构组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>28</td>
          <td>Okhttp3 SDK</td>
          <td>HTTP和相关协议的底层框架</td>
          <td>无</td> 
          <td>Square公司</td>
        </tr>
        <tr>
          <td>29</td>
          <td>OauthSignpost SDK</td>
          <td>基础架构组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>30</td>
          <td>MagicIndicator SDK</td>
          <td>基础架构组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>31</td>
          <td>Blurry SDK</td>
          <td>基础架构组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>32</td>
          <td>Realm SDK</td>
          <td>基础架构组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>33</td>
          <td>RxJava-2 SDK</td>
          <td>加载响应组件</td>
          <td>无</td> 
          <td>ReactiveX公司</td>
        </tr>
        <tr>
          <td>34</td>
          <td>GridViewwithHeaderandFooter SDK</td>
          <td>基础架构组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>35</td>
          <td>YouthBanner SDK</td>
          <td>图片轮播组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>36</td>
          <td>WheelView SDK</td>
          <td>滚轮控件组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>37</td>
          <td>ViewPagerIndicator SDK</td>
          <td>指示器组件</td>
          <td>无</td> 
          <td>开源项目</td>
        </tr>
        <tr>
          <td>38</td>
          <td>微信开放平台 SDK</td>
          <td>微信分享、登录、收藏、支付功能</td>
          <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>  
          <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>39</td>
        <td>QQ登录 SDK</td>
        <td>用户使用QQ账号登录应用</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。 </td> 
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>40</td>
        <td> 腾讯地图定位 SDK</td>
        <td>提供腾讯地图定位服务</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>  
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>41</td>
        <td>腾讯浏览服务 SDK</td>
        <td>优化移动端webview体验</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。 </td> 
        <td>深圳市腾讯计算机系统有限公司</td>
      </tr>
      <tr>
        <td>42</td>
        <td>RxPermissions SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>43</td>
        <td>Otto SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>44</td>
        <td>AndroidCrop SDK</td>
        <td>图像裁剪组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>45</td>
        <td>新浪微博开放平台 SDK</td>
        <td>提供微博分享功能</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td> 
        <td>北京微梦创科网络技术有限公司</td>
      </tr>
      <tr>
        <td>46</td>
        <td>微博帐号登录 SDK</td>
        <td>使用微博帐号登录</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>  
        <td>北京微梦创科网络技术有限公司</td>
      </tr>
      <tr>
        <td>47</td>
        <td>SmartRefreshLayout SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>48</td>
        <td>OAID_SAMSUNG SDK</td>
        <td>获取设备标识组件</td>
        <td>OAID（开放匿名设备标识符）</td>
        <td>中国信息通信研究院</td>
      </tr>
      <tr>
        <td>49</td>
        <td>OAID_ZUI SDK</td>
        <td>获取设备标识组件</td>
        <td>OAID（开放匿名设备标识符）</td>
        <td>中国信息通信研究院</td>
      </tr>
      <tr>
        <td>50</td>
        <td>Leonids SDK</td>
        <td>基础工具组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>51</td>
        <td>UniversalImageLoader SDK</td>
        <td>图像加载组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>52</td>
        <td>SwipeDelMenuLayout SDK</td>
        <td>侧滑菜单组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>53</td>
        <td>TimePickerDialog SDK</td>
        <td>时间选择组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>54</td>
        <td>OAID_HUAWEI SDK</td>
        <td>获取设备标识组件</td>
        <td>OAID（开放匿名设备标识符）</td>
        <td>中国信息通信研究院</td>
      </tr>
      <tr>
        <td>55</td>
        <td>华为帐号 SDK</td>
        <td>集成华为帐号功能</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td> 
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>56</td>
        <td>华为更新 SDK</td>
        <td>华为自升级服务</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>57</td>
        <td>HMSSdkIAP SDK</td>
        <td>华为服务基础组件</td>
        <td>无</td> 
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>58</td>
        <td>HuaweiHiAnalytics SDK</td>
        <td>华为数据组件</td>
        <td>设备标识符（OAID、Android ID、AAID）、网络状态（网络类型、运营商信息）</td>
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>59</td>
        <td>华为HMS SDK</td>
        <td>华为HMS更新服务</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。 </td> 
        <td>华为技术有限公司</td>
      </tr>
      <tr>
        <td>60</td>
        <td>Cardboard SDK</td>
        <td>虚拟现实(VR)工具组件</td>
        <td>无</td>
        <td>开源项目</td>
      </tr>
      <tr>
        <td>61</td>
        <td>ExoPlayer SDK</td>
        <td>媒体播放器组件</td>
        <td>无</td> 
        <td>Google公司</td>
      </tr>
      <tr>
        <td>62</td>
        <td>谷歌Gson SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>Google公司</td>
      </tr>
      <tr>
        <td>63</td>
        <td>Google Protobuf SDK</td>
        <td>序列化框架组件</td>
        <td>无</td> 
        <td>Google公司</td>
      </tr>
      <tr>
        <td>64</td>
        <td>SpinKit SDK</td>
        <td>动画加载组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>65</td>
        <td>ReLinker SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>Keepsafe公司</td>
      </tr>
      <tr>
        <td>66</td>
        <td>FlycoDialog SDK</td>
        <td>对话框组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>67</td>
        <td>Shimmer SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>68</td>
        <td>MultipleImageSelect SDK</td>
        <td>图片选择组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>69</td>
        <td>AndroidVideoCache SDK</td>
        <td>视频缓存组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>70</td>
        <td>BigkooPickerview SDK</td>
        <td>时间选择器组件</td>
        <td>无</td> 
        <td>深圳必酷科技有限公司</td>
      </tr>
      <tr>
        <td>71</td>
        <td>OAID_ASUS SDK</td>
        <td>获取设备标识组件</td>
        <td>OAID（开放匿名设备标识符）</td>
        <td>中国信息通信研究院</td>
      </tr>
      <tr>
        <td>72</td>
        <td>支付宝安全 SDK</td>
        <td>蚂蚁金服提供的安全插件</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>  
        <td>蚂蚁金服（杭州）网络技术有限公司</td>
      </tr>
      <tr>
        <td>73</td>
        <td>支付宝客户端支付安全 SDK</td>
        <td>蚂蚁金服提供的安全插件</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>  
        <td>蚂蚁金服（杭州）网络技术有限公司</td>
      </tr>
      <tr>
        <td>74</td>
        <td>AliFastJson SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>杭州阿里巴巴广告有限公司</td>
      </tr>
      <tr>
        <td>75</td>
        <td>阿里ARouter SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>阿里云计算有限公司</td>
      </tr>
      <tr>
        <td>76</td>
        <td>阿里百川组件 SDK</td>
        <td>数据分析组件</td>
        <td>设备基础信息：唯一设备识别码IMEI、IMSI信息、设备制造商、设备品牌、设备型号、设备名称、设备操作系统信息、设备配置信息、设备环境信息；设备网络信息：网络运营商信息、网络类型、网络状态；设备应用信息：应用名称、应用版本。</td>  
        <td>阿里云计算有限公司</td>
      </tr>
      <tr>
        <td>77</td>
        <td>AirbnbLottie SDK</td>
        <td>基础架构组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>78</td>
        <td>AndroidSMS SDK</td>
        <td>短信验证码工具</td>
        <td>无</td> 
        <td>上海游昆信息技术有限公司</td>
      </tr>
      <tr>
        <td>79</td>
        <td>Kpswitch SDK</td>
        <td>键盘面板组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>80</td>
        <td>京东选择器 SDK</td>
        <td>地址选择组件</td>
        <td>无</td> 
        <td>北京京东叁佰陆拾度电子商务有限公司</td>
      </tr>
      <tr>
        <td>81</td>
        <td>ButterKnife SDK</td>
        <td>视图布局组件</td>
        <td>无</td> 
        <td>开源项目</td>
      </tr>
      <tr>
        <td>82</td>
        <td>com.heartide</td>
        <td>提供复制粘贴业务</td>
        <td>获取粘贴板信息</td>
        <td>广州心与潮信息科技有限公司</td>
      </tr>
      <tr>
        <td>83</td>
        <td>MobTech SMSSDK</td>
        <td>提供短信验证功能</td>
        <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取iccid。</td>
        <td>上海游昆信息技术有限公司</td>
      </tr>
      <tr>
        <td>84</td>
        <td>MobTechSDK</td>
        <td>提供短信验证功能</td>
        <td>获取IP地址、网卡、MAC地址、国际移动设备识别码（IMEI、IMSI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号、报错日志、获取iccid。</td>
        <td>上海游昆信息技术有限公司</td>
      </tr>
      <tr>
        <td>85</td>
        <td>友盟组件化基础库 SDK</td>
        <td>提供统计分析服务</td>
        <td>设备标志符，MAC地址，电话状态，网络状态，idfa，idfv，位置信息，唯一设备识别码、获取设备序列号（如IMEI、Android_ID、IDFA、OPENUDID、GUID、IP地址、SIM卡 IMSI、MAC、OAID、ICCID、GAID 信息）、获取应用列表、获取iccid</td>
        <td>友盟同欣（北京）科技有限公司</td>
      </tr>
    </tbody>
  </table>
  <p class="level2">附件三：《iOS 版本功能使用所需权限列表》</p>
  <table>
    <thead>
      <tr>
        <th>心潮功能</th>
        <th>功能说明</th>
        <th>权限使用说明</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>个人头像</td>
        <td>为用户提供设置、更换头像的功能</td>
        <td>允许App使用摄像头并访问相册、图片内容</td>
      </tr>
      <tr>
        <td>心率监测、快速减压、考前减压功能</td>
        <td>为用户提供分析心率变化的功能</td>
        <td>允许程序访问摄像头进行拍照</td>
      </tr>
    </tbody>
  </table>
  <p class="level2">附件四：《Android 版本功能使用所需权限列表》</p>
  <table>
    <thead>
      <tr>
        <th>心潮功能</th>
        <th>功能说明</th>
        <th>权限使用说明</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>个人头像</td>
        <td>为用户提供设置、更换头像的功能</td>
        <td>允许App使用摄像头并访问相册、图片内容</td>
      </tr>
      <tr>
        <td>心率监测、快速减压、考前减压功能</td>
        <td>为用户提供分析心率变化的功能</td>
        <td>允许程序访问摄像头进行拍照</td>
      </tr>
    </tbody>
  </table>
</div></template>

<script>
export default {
  name: 'privacy',
  data() {
    return {}
  },
  created() {
    document.getElementsByTagName("title")[0].innerHTML = "&#65279;"
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>.privacy {
  font-size: 16px;
  text-align: left;
  padding: 15px 15px 200px 15px;
  width: 100%;
  box-sizing: border-box;
}

.title {
  text-align: center;
  margin: 50px 0;
  display: block;
  font-size: 20px;
  font-weight: bold;
}

.level1 {
  font-size: 20px;
  font-weight: bold;
  margin: 30px 0;
}

.level2,
.level3 {
  font-size: 20px;
  font-weight: bold;
  margin: 30px 0;
}

.level4 {
  font-size: 20px;
  margin: 30px 0;
}

p {
  font-size: 16px;
  margin: 25px 0;
  word-break: break-word;
}

.strong {
  font-weight: 700;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  th {
    font-weight: 700;
    border: 1px solid black;
    background-color: #E6EBF0;
    padding: 5px;
  }

  td {
    border: 1px solid black;
    padding: 5px;
    overflow-wrap: break-word;
  }
}</style>
